import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    List,
    ListItem,
    ListItemText,
    Divider
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

const costExplanations = {
    CLT: {
        title: 'Cálculo de Custos CLT',
        items: {
            salarioBase: 'Salário base mensal bruto do funcionário',
            decimoTerceiro: '1/12 do salário base para provisão do 13º',
            feriasProvisao: 'Provisão de férias (salário + 1/3) dividido por 12 meses',
            fgts: '8% sobre (Salário Base + 13º + Férias)',
            encargos: 'Encargos sociais sobre a folha (INSS Patronal, RAT/SAT, INSS Terceiros, Salário Educação)',
            valeTransporte: 'Custo do VT (valor diário × dias úteis) menos desconto de 6% do salário (quando aplicável)',
            valeRefeicao: 'Valor diário (R$ 32,89) × dias úteis (21)',
            valeAlimentacao: 'Valor diário (R$ 21,74) × dias úteis (21)',
            auxilioSaude: 'Valor mensal fixo do plano de saúde (R$ 500,00)',
            custoTotal: 'Soma de todos os custos mensais',
            fatorMultiplicador: 'Custo total dividido pelo salário base'
        }
    },
    PJ: {
        title: 'Cálculo de Custos PJ',
        items: {
            salarioBase: 'Valor mensal bruto do contrato',
            valeTransporte: 'Valor diário (R$ 14,70) × dias úteis (21), sem desconto',
            valeRefeicao: 'Valor diário (R$ 32,89) × dias úteis (21)',
            valeAlimentacao: 'Valor diário (R$ 21,74) × dias úteis (21)',
            auxilioSaude: 'Valor mensal fixo do plano de saúde (R$ 500,00)',
            custoTotal: 'Soma do valor do contrato com os benefícios',
            fatorMultiplicador: 'Custo total dividido pelo valor do contrato'
        }
    },
    SCP: {
        title: 'Cálculo de Custos SCP',
        items: {
            salarioBase: 'Valor mensal bruto do contrato',
            decimoTerceiro: '1/12 do valor do contrato para provisão do 13º',
            feriasProvisao: '1/12 do valor do contrato para provisão de férias',
            custoTotal: 'Soma do valor do contrato com as provisões',
            fatorMultiplicador: 'Custo total dividido pelo valor do contrato'
        }
    }
};

interface ContractCostHelpProps {
    open: boolean;
    onClose: () => void;
}

export const ContractCostHelp: React.FC<ContractCostHelpProps> = ({ open, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                Explicação dos Cálculos por Tipo de Contrato
            </DialogTitle>
            <DialogContent>
                {Object.entries(costExplanations).map(([type, { title, items }]) => (
                    <Accordion key={type}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h6">{title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <List>
                                {Object.entries(items).map(([key, explanation], index) => (
                                    <React.Fragment key={key}>
                                        <ListItem>
                                            <ListItemText
                                                primary={key.replace(/([A-Z])/g, ' $1').toLowerCase()}
                                                secondary={explanation}
                                                primaryTypographyProps={{
                                                    style: { textTransform: 'capitalize' }
                                                }}
                                            />
                                        </ListItem>
                                        {index < Object.entries(items).length - 1 && <Divider />}
                                    </React.Fragment>
                                ))}
                            </List>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    );
}; 